export const FULFILLED = "FULFILLED";
export const IDLE = "IDLE";
export const PENDING = "PENDING";
export const REJECTED = "REJECTED";